// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 排序方式枚举 枚举类
 * 排序方式枚举
 */
export enum EnumSortStyle {
  /** 升序 : 升序 */
  Asc = 1,
  /** 降序 : 降序 */
  Desc = 2
}

/**
 * 排序方式枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumSortStyleMD {
  private static items = [
    new EnumItemMD('Asc', 1, '升序', '升序'),
    new EnumItemMD('Desc', 2, '降序', '降序')
  ];

  static getItem(enumItem: EnumSortStyle) {
    return this.items.find(item => item.name === EnumSortStyle[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
